import { SupportedCountry } from 'modules/payroll_employees/lib/enums'

import Germany from './Germany'
import Italy from './Italy'
import Portugal from './Portugal'

interface Props {
  employeeId: string
  mandatory?: boolean
  readonly?: boolean
  country: string
  setSubmitEventHandler: (eventHandler: () => void) => void
  setIdentifiersDirty: (dirty: boolean) => void
  setIdentifiersError?: (error: boolean) => void
}

const Identifiers = ({
  employeeId,
  mandatory = false,
  readonly = false,
  country,
  setSubmitEventHandler,
  setIdentifiersDirty,
  setIdentifiersError,
}: Props) => {
  switch (country) {
    case SupportedCountry.Germany:
      return (
        <Germany
          employeeId={employeeId}
          mandatory={mandatory}
          readonly={readonly}
          setSubmitEventHandler={setSubmitEventHandler}
          setIdentifiersDirty={setIdentifiersDirty}
          setIdentifiersError={setIdentifiersError}
        />
      )

    case SupportedCountry.Italy:
      return (
        <Italy
          employeeId={employeeId}
          mandatory={mandatory}
          readonly={readonly}
          setSubmitEventHandler={setSubmitEventHandler}
          setIdentifiersDirty={setIdentifiersDirty}
          setIdentifiersError={setIdentifiersError}
        />
      )

    case SupportedCountry.Portugal:
      return (
        <Portugal
          employeeId={employeeId}
          mandatory={mandatory}
          readonly={readonly}
          setSubmitEventHandler={setSubmitEventHandler}
          setIdentifiersDirty={setIdentifiersDirty}
        />
      )

    default:
      return null
  }
}

export default Identifiers
